module.exports = __webpack_public_path__ + "img/16.941a508d.jpg";